import React, { useMemo } from 'react'
import { get } from 'lodash'
import LinearProgress from '@material-ui/core/LinearProgress'
import Error from 'components/error'
import LeadsView from './leads-view'

export default React.memo(
  ({
    loading,
    error,
    data = [],
    coachingLeadContactMethodOptions,
    refetch,
    freeTierLimitsReached,
    tab,
  }) => {
    const searchableItems = useMemo(
      () =>
        data.map(item => ({
          ...item,
          firstName: get(item, ['contact', 'firstName']) ?? '',
          lastName: get(item, ['contact', 'lastName']) ?? '',
        })),
      [data],
    )

    if (loading) return <LinearProgress color="primary" />
    if (error && searchableItems.length === 0) {
      return <Error error={error} />
    }

    return (
      <LeadsView
        searchableItems={searchableItems}
        coachingLeadContactMethodOptions={coachingLeadContactMethodOptions}
        refetch={refetch}
        freeTierLimitsReached={freeTierLimitsReached}
        tab={tab}
      />
    )
  },
)
